class ProductNavigation extends HTMLElement {
  constructor() {
    super();

    this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
    this.intersectionHandler = this.intersectionHandler.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    this.addToCartObserver = null;
    this.backInStockObserver = null;

    this.addToCartButtonEl = null;
    this.backInStockButtonEl = null;
  }

  intersectionHandler(entries) {
    entries.forEach((entry) => {
      entry.target.classList.toggle('is-visible', entry.isIntersecting);
    });
  }

  handleTransitionEnd(event) {
    if (event.propertyName === "opacity") {
      if (!this.classList.contains('active')) {
        this.classList.add('nav-hidden');
      }
    }
  }

  connectedCallback() {
    this.addToCartButtonEl = document.querySelector('.product__info-wrapper .product-form__submit-watcher');
    this.backInStockButtonEl = document.querySelector('.product__info-wrapper .trigger-back-in-stock-btn');

    if (this.addToCartButtonEl) {
      this.addToCartObserver = new IntersectionObserver(this.intersectionHandler, {
        rootMargin: '-80px 0px 0px 0px',
      });
      this.addToCartObserver.observe(this.addToCartButtonEl);
    }

    if (this.backInStockButtonEl) {
      this.backInStockObserver = new IntersectionObserver(this.intersectionHandler, {
        rootMargin: '-80px 0px 0px 0px',
      });
      this.backInStockObserver.observe(this.backInStockButtonEl);
    }


    this.addEventListener("transitionend", this.handleTransitionEnd);
    this.addEventListener("click", this.handleChangeLink);
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  }

  handleScroll() {
    const { scrollHeight, scrollTop, clientHeight } = document.documentElement;
    this.classList.toggle('is-at-bottom', Math.abs(scrollHeight - scrollTop - clientHeight) < 10);
  }

  handleChangeLink(event) {
    const link = event.target.closest('.sticky-atc__change-link');
    if (!link) return;
    event.preventDefault();
    const target = document.querySelector(event.target.hash);
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    if (target) target.scrollIntoView({ behavior });
  }

  disconnectedCallback() {
    if (this.addToCartObserver) {
      this.addToCartObserver.disconnect();
      this.addToCartObserver = null;
    }
    if (this.backInStockObserver) {
      this.backInStockObserver.disconnect();
      this.backInStockObserver = null;
    }

    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.removeEventListener("click", this.handleChangeLink);
    window.removeEventListener("scroll", this.handleScroll);
  }

  // Initial check for visibility
  _isElementInViewport(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth) &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }
}

customElements.define('product-navigation', ProductNavigation);
